import {
    ADD_SKILL_GROUP,
    ADD_SKILL_GROUP_GARBAGE,
    ADD_USER,
    ARCHIVE_TABLE_TOGGLE,
    CAMPAIGN_ACD_FIELD,
    CAMPAIGN_CLEAR_ACD,
    CHANGE_SKILL_GROUP_LEVEL,
    CHANGE_SKILL_GROUP_GARBAGE_INDEX,
    CHANGED_COMPANIES_DATA,
    CHANGED_SCHEDULER,
    CLEAR_ALL_STATES,
    CLEAR_CAMPAIGN_CONTACTS,
    CLEAR_FILTERS,
    SET_CAMPAIGNS_UI_FILTERS,
    CLEAR_LEADS_FILTERS,
    SET_LEADS_UI_FILTERS,
    COMPANY_FIELD,
    COMPANY_STATE_SAVE,
    DELETE_SKILL_GROUP,
    DELETE_SKILL_GROUP_GARBAGE,
    DELETE_USER,
    DIALOG_VISIBLE,
    GET_ALL_SIMPLE_USERS,
    GET_CAMPAIGN_ACD_DICTIONARY,
    GET_CAMPAIGN_CONTACTS,
    GET_CAMPAIGN_CONTACTS_PAGINATION,
    GET_CONTACTS_BY_CAMPAIGN_DASHBOARD,
    GET_COMPANIES,
    GET_COMPANIES_ARCHIVED,
    GET_COMPANIES_DIRECTORIES_CAMPAIGN_STRATEGY,
    GET_COMPANIES_DIRECTORIES_CAMPAIGN_STRATEGY_ERROR,
    GET_COMPANIES_DIRECTORIES_CAMPAIGN_TYPE,
    GET_COMPANIES_DIRECTORIES_PHONE_TYPE,
    GET_COMPANIES_DIRECTORIES_SCHEDULER_TYPE,
    GET_COMPANIES_DIRECTORIES_TRANKS_PHONE,
    GET_COMPANY,
    GET_NOTIFICATION,
    GET_NOTIFICATION_ERROR,
    GET_PAGINATION,
    GET_USERS,
    GOOGLE_AUTH_SHOW_ERROR,
    HIDE_COMPANY_CREATE_MESSAGE,
    HIDE_COMPANY_SAVE_MESSAGE,
    HIDE_ERROR,
    HIDE_ERROR_MESSAGE,
    HIDE_LOADER,
    HIDE_LOADER_STRATEGY_DICT,
    INITIAL_COMPANIES_DATA,
    RESET_SCHEDULER,
    SELECTED_COMPANY_ID,
    SET_CALL_CYCLES,
    SET_CAMPAIGN_CONTACTS_PAGE_SIZE,
    SET_CAMPAIGN_TRUNK_IDS,
    SET_COMPANY_ROOT_FIELD,
    SET_CONTACTS_LOADER,
    SET_CONTACTS_BY_CAMPAIGN_DASHBOARD_LOADING,
    SET_CURRENT_PAGE,
    SET_CURRENT_SIZE,
    SET_ERROR_FIELDS,
    SET_INTERVAL_ID,
    SET_LOADING,
    SET_TRANK_ID,
    SHOW_CAMPAIGN_DETAIL_LOADING,
    SHOW_COMPANY_CREATE_MESSAGE,
    SHOW_COMPANY_DELETE_MESSAGE,
    SHOW_COMPANY_SAVE_MESSAGE,
    SHOW_ERROR,
    SHOW_ERROR_FIELD,
    SHOW_ERROR_MESSAGE,
    SHOW_GET_ARCHIVE_COMPANIES_ERROR,
    SHOW_GET_CAMPAIGN_DIRECTORIES_CAMPAIGN_TYPE,
    SHOW_GET_CAMPAIGN_DIRECTORIES_PHONE_TYPE_ERROR,
    SHOW_GET_COMPANIES_DIRECTORIES_TRANKS_PHONE_ERROR,
    SHOW_GET_COMPANIES_INTERVAL_ERROR,
    SHOW_LOADER,
    SHOW_LOADER_STRATEGY_DICT,
    SHOW_UPDATED_ERROR,
    TOGGLE_CAMPAIGN_DAY_ACTIVE,
    SET_CAMPAIGN_AMD_SETTINGS,
    UPDATE_CAMPAIGN_SCHEDULER_TIME,
    SET_STATE_CAMPAIGN,
    SET_ALL_CAMPAIGNS,
    GET_CAMPAIGNS_FOR_LEADS_LIST,
    GET_CAMPAIGN_LEADS_FILES_HISTORY,
    SET_CAMPAIGN_LEADS_FILES_HISTORY_LOADER,
    GET_CAMPAIGN_LEADS_FILES_PAGINATION,
    SET_CURRENT_CAMPAIGN_LEADS_FILES_PAGE,
    SET_CURRENT_CAMPAIGN_LEADS_FILES_SIZE
} from "../types/types";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {RelationCampaignUsers, resolveCallsDialerType} from "types/types";
import {CHANGE_CAMPAIGN_USER_LEVEL} from "../types/typesUsersList";

export interface CompaniesListState {
    archiveTableToggle: boolean;
    dialogVisible: boolean;
    selectedCompanyId: any;
    clearFilters: any;
    clearLeadsFilters: any;
    companiesList: any[];
    pagination: {
        countPage: number;
        totalItems: number;
    };
    paginationPage: number;
    paginationSize: number;
    companiesListArchived: any[];
    companiesData: any;
    trunksPairs: any[];
    usersData: any[];
    allSimpleUsers: any[];
    campaignContacts: {
        countPage: number;
        totalItems: number;
        items: any[];
        all?: any;
        phoneTypes?: any;
        types?: any;
        summary?: any;
        statistic?: any;
        leadContacts?: any;
        coincidence?: any;
    };
    campaignContactsPageSize: {
        page: number;
        size: number;
    };
    campaignContactsPagination: {
        hasNext: 0,
        pageNumber: 0,
    };
    campaignLeadsDashboard: any;
    campaignLeadsDashboardLoading: boolean;
    contactsLoader: boolean;
    companiesDirectoryCampaignType: any[];
    campaignDirectoriesPhoneType: any[];
    companiesDirectoryCampaignStrategy: any[];
    companiesDirectoryTranksPhones: any[];
    companiesDirectorySchedulerType: any[];
    campaignDirectoryCampaignType: any[];
    loading: boolean;
    detailsLoading: boolean;
    loadingStrategyDict: boolean;
    error: boolean;
    errorUpdate: boolean;
    errorMessage: any;
    companyCreateMessage: boolean;
    companySaveMessage: boolean;
    companyDeleteMessage: boolean;
    companyStateSave: boolean;
    changeScheduler: boolean;
    changedCompaniesData: boolean;
    errorField: any;
    errorFields: any;
    notificationCopy: any;
    notificationLaunch: any;
    notificationCancel: any;
    notificationSuspend: any;
    notificationSuccess: any;
    notificationError: any;
    notificationUpdated: any;
    notificationUpdatedError: any;
    notificationSaveChanges: any;
    intervalId: any;
    getCompaniesIntervalError: boolean;
    getArchiveCompaniesError: boolean;
    getCampaignDirectoriesPhoneTypeError: boolean;
    getCampaignDirectoriesCampaignTypeError: boolean;
    getCampaignDirectoriesGetTranksPhonesError: boolean;
    getCampaignDirectoriesStrategyError: boolean;
    getNotificationError: boolean;
    userLoading: boolean;
    googleAuthError: boolean;
    userDeleteQuestionsText: any;
    userDeleteMessageText: any;
    stateCampaign: any;
    allCampaigns: any[];
    campaignsForLeadsList: any[];
    campaignLeadsFilesHistory: any[];
    campaignLeadsFilesHistoryLoader: boolean;
    campaignLeadsFilesPagination: {
        hasNext: number;
        pageNumber: number;
    };
    campaignLeadsFilesPaginationPage: number;
    campaignLeadsFilesPaginationSize: number;
}

const initialState: CompaniesListState = {
    archiveTableToggle: true,
    dialogVisible: false,
    selectedCompanyId: null,
    clearFilters: {
        campaignTypeId: {value: null, matchMode: FilterMatchMode.IN},
        branchId: {value: null, matchMode: FilterMatchMode.IN},
        name: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        statusId: {value: null, matchMode: FilterMatchMode.IN},
        campaignId: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        isGeneralTrunk: {value: null, matchMode: FilterMatchMode.IN},
        isActive: {value: null, matchMode: FilterMatchMode.IN},
        inLineCountCalls: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        isInLineCountCalls: {value: null, matchMode: FilterMatchMode.IN},
    },
    clearLeadsFilters: {
        phoneTypeId: {value: null, matchMode: FilterMatchMode.IN},
        contactName: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        phoneNo: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        description: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        result: {value: null, matchMode: FilterMatchMode.IN},
        isActive: {value: null, matchMode: FilterMatchMode.IN},
        ownerUserName: {value: null, matchMode: FilterMatchMode.IN},
        createdDateTime: {value: null, matchMode: FilterMatchMode.IN},
        lastCall: {value: null, matchMode: FilterMatchMode.IN},
        newCall: {value: null, matchMode: FilterMatchMode.IN}
    },
    companiesList: [],
    pagination: {
        countPage: 0,
        totalItems: 0,
    },
    paginationPage: 1,
    paginationSize: 10,
    companiesListArchived: [],
    companiesData: {
        campaign: {
            isSkillGroup: false,
            campaignId: null,
            name: null,
            description: null,
            isArchived: false,
            statusId: 0,
            campaignTypeId: 201,
            operatorStrategyTypeId: 308,
            countUsers: 0,
            countContacts: 0,
            priority: 0,
            schedulerId: 0,
            progressContacts: null,
            progressCampaign: 0,
            employmentOperators: 0,
            wellComplet: 0,
            firstCallOperator: true,
            isGeneralTrunk: true,
            isDoneContactCount: 0,
            branchId: null,
            isInLineCountCalls: true,
            isRevolver: false,
            timeoutExternalOnAnswer: 60,
            callsDialerType: 1,
            garbageStrategyOperators: 308
        },
        campaignACD: null,
        campaignAMD: {
            hangup_on_machine: ['MAXWORDLENGTH', 'MAXWORDS', 'LONGGREETING', 'INITIALSILENCE']
        },
        campaignData: {
            createdByUserId: null,
            updatedByUserId: null,
            createdDateTime: null,
            updatedDateTime: null,
        },
        campaignUsers: [],
        relationCampaignContacts: [],
        callCycles: [],
        skillGroups: [],
        skillGroupsGarbage: [],
        scheduler: null,
        trunkId: null,
        trunks: [],
        permission: {
            branchIsBlock: true,
            usersIsBlock: false,
            skillGroupsIsBlock: false,
            trunksIsBlock: false,
            audioIsBlock: false,
            ivrIsBlock: false,
        }
    },
    trunksPairs: [],
    usersData: [],
    allSimpleUsers: [],
    campaignContacts: {
        countPage: 1,
        totalItems: 10,
        items: [],
    },
    campaignContactsPageSize: {
        page: 1,
        size: 10
    },
    campaignContactsPagination: {
        hasNext: 0,
        pageNumber: 0,
    },
    campaignLeadsDashboard: null as any,
    campaignLeadsDashboardLoading: false,
    contactsLoader: false,
    companiesDirectoryCampaignType: [],
    campaignDirectoriesPhoneType: [],
    companiesDirectoryCampaignStrategy: [],
    companiesDirectoryTranksPhones: [],
    companiesDirectorySchedulerType: [],
    campaignDirectoryCampaignType: [],
    loading: false,
    detailsLoading: false,
    loadingStrategyDict: false,
    error: false,
    errorUpdate: false,
    errorMessage: null,
    companyCreateMessage: false,
    companySaveMessage: false,
    companyDeleteMessage: false,
    companyStateSave: false,
    changeScheduler: false,
    changedCompaniesData: false,
    errorField: null,
    errorFields: null,
    notificationCopy: null,
    notificationLaunch: null,
    notificationCancel: null,
    notificationSuspend: null,
    notificationSuccess: null,
    notificationError: null,
    notificationUpdated: null,
    notificationUpdatedError: null,
    notificationSaveChanges: null,
    intervalId: null,
    getCompaniesIntervalError: false,
    getArchiveCompaniesError: false,
    getCampaignDirectoriesPhoneTypeError: false,
    getCampaignDirectoriesCampaignTypeError: false,
    getCampaignDirectoriesGetTranksPhonesError: false,
    getCampaignDirectoriesStrategyError: false,
    getNotificationError: false,
    userLoading: false,
    googleAuthError: false,
    userDeleteQuestionsText: null,
    userDeleteMessageText: null,
    stateCampaign: null,
    allCampaigns: [],
    campaignsForLeadsList: [],
    campaignLeadsFilesHistory: [],
    campaignLeadsFilesHistoryLoader: false,
    campaignLeadsFilesPagination: {
        hasNext: 0,
        pageNumber: 0
    },
    campaignLeadsFilesPaginationPage: 1,
    campaignLeadsFilesPaginationSize: 10
}

export const CompaniesListReducer = (state: CompaniesListState = initialState, action: any): CompaniesListState => {
    switch (action.type) {
        case ARCHIVE_TABLE_TOGGLE:
            return {...state, archiveTableToggle: action.payload}
        case DIALOG_VISIBLE:
            return {...state, dialogVisible: action.payload}
        case SELECTED_COMPANY_ID:
            return {...state, selectedCompanyId: action.payload}
        case COMPANY_FIELD:
            return {
                ...state, companiesData:
                    {
                        ...state.companiesData,
                        [action.payload.section]: {
                            // @ts-ignore
                            ...state.companiesData[action.payload.section],
                            [action.payload.fieldName]: action.payload.value,
                        }
                    }
            }
        case CLEAR_FILTERS:
            return {
                ...state, clearFilters: {
                    campaignTypeId: {value: null, matchMode: FilterMatchMode.IN},
                    branchId: {value: null, matchMode: FilterMatchMode.IN},
                    name: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    statusId: {value: null, matchMode: FilterMatchMode.IN},
                    campaignId: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    isGeneralTrunk: {value: null, matchMode: FilterMatchMode.IN},
                    inLineCountCalls: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    isInLineCountCalls: {value: null, matchMode: FilterMatchMode.IN},
                }
            }
        case SET_CAMPAIGNS_UI_FILTERS: {
            const nextFilters = { ...state.clearFilters };
            Object.entries(action.payload || {}).forEach(([filterField, filterValue]) => {
                // @ts-ignore
                const existingFilter = nextFilters[filterField];
                if (!existingFilter) return;
                if ('constraints' in existingFilter) {
                    // @ts-ignore
                    nextFilters[filterField] = {
                        ...existingFilter,
                        constraints: [
                            {
                                ...existingFilter.constraints[0],
                                value: filterValue
                            }
                        ]
                    };
                } else {
                    // @ts-ignore
                    nextFilters[filterField] = {
                        ...existingFilter,
                        value: filterValue
                    };
                }
            });
            return {
                ...state,
                clearFilters: nextFilters
            };
        }
        case CLEAR_LEADS_FILTERS:
            return {
                ...state, clearLeadsFilters: {
                    phoneTypeId: {value: null, matchMode: FilterMatchMode.IN},
                    contactName: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    phoneNo: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    description: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    result: {value: null, matchMode: FilterMatchMode.IN},
                    isActive: {value: null, matchMode: FilterMatchMode.IN},
                    ownerUserName: {value: null, matchMode: FilterMatchMode.IN},
                    createdDateTime: {value: null, matchMode: FilterMatchMode.IN},
                    lastCall: {value: null, matchMode: FilterMatchMode.IN},
                    newCall: {value: null, matchMode: FilterMatchMode.IN}
                }
            }
        case SET_LEADS_UI_FILTERS: {
            const nextFilters = { ...state.clearLeadsFilters };
            Object.entries(action.payload || {}).forEach(([filterField, filterValue]) => {
                // @ts-ignore
                const existingFilter = nextFilters[filterField];
                if (!existingFilter) return;
                if ('constraints' in existingFilter) {
                    // @ts-ignore
                    nextFilters[filterField] = {
                        ...existingFilter,
                        constraints: [
                            {
                                ...existingFilter.constraints[0],
                                value: filterValue
                            }
                        ]
                    };
                } else {
                    // @ts-ignore
                    nextFilters[filterField] = {
                        ...existingFilter,
                        value: filterValue
                    };
                }
            });
            return {
                ...state,
                clearLeadsFilters: nextFilters
            };
        }
        case GET_COMPANIES:
            return {...state, companiesList: action.payload}
        case GET_CAMPAIGN_CONTACTS:
            return {
                ...state,
                campaignContacts: {
                    ...action.payload,
                    totalItems: action.payload.totalItems,
                    countPage: action.payload.countPage,
                    items: action.payload.items
                }
            }
        case GET_CONTACTS_BY_CAMPAIGN_DASHBOARD:
            return {...state, campaignLeadsDashboard: action.payload}
        case SET_CONTACTS_BY_CAMPAIGN_DASHBOARD_LOADING:
            return {...state, campaignLeadsDashboardLoading: action.payload}
        case CLEAR_CAMPAIGN_CONTACTS:
            return {...state, campaignContacts: {totalItems: 0, countPage: 0, items: []}}
        case SET_CAMPAIGN_CONTACTS_PAGE_SIZE:
            return {...state, campaignContactsPageSize: {page: action.payload.page, size: action.payload.size}}
        case GET_PAGINATION:
            return {...state, pagination: {countPage: action.payload.countPage, totalItems: action.payload.totalItems}}
        case SET_CURRENT_PAGE:
            return {...state, paginationPage: action.payload}
        case SET_CURRENT_SIZE:
            return {...state, paginationSize: action.payload}
        case GET_COMPANIES_ARCHIVED:
            return {...state, companiesListArchived: action.payload}
        case GET_COMPANY: {
            const rawGarbage = action.payload.skillGroupsGarbage ?? [];
            const sortedGarbage = [...rawGarbage].sort(
                (a: any, b: any) =>
                    (a.displayOrder ?? a.skillGroupLevel ?? 0) - (b.displayOrder ?? b.skillGroupLevel ?? 0)
            );
            const skillGroupsGarbage = sortedGarbage.map((g: any, index: number) => ({
                ...g,
                skillGroupId: g.skillGroupId ?? g.id,
                displayOrder: index + 1,
            }));
            const rawCampaign = action.payload.campaign ?? {};
            const {
                isCyclically: _isCyclically,
                isSequentiallyByCycle: _isSequentiallyByCycle,
                countCycles: _countCycles,
                ...campaignRest
            } = rawCampaign;
            return {
                ...state,
                companiesData: {
                    ...action.payload,
                    skillGroupsGarbage,
                    campaign: {
                        ...campaignRest,
                        garbageStrategyOperators:
                            rawCampaign?.garbageStrategyOperators ??
                            action.payload.garbageStrategyOperators ??
                            308,
                        callsDialerType: resolveCallsDialerType(rawCampaign),
                    },
                    callCycles: (action.payload.callCycles ?? []).map((cycle: any, index: number, cycles: any[]) => ({
                        ...cycle,
                        totalCount: cycle?.totalCount ?? cycles[0]?.totalCount ?? 1
                    })),
                },
            };
        }
        case GET_USERS:
            return {...state, usersData: action.payload}
        case GET_ALL_SIMPLE_USERS:
            return {...state, allSimpleUsers: action.payload}
        case GET_COMPANIES_DIRECTORIES_CAMPAIGN_TYPE:
            return {...state, companiesDirectoryCampaignType: action.payload}
        case GET_COMPANIES_DIRECTORIES_SCHEDULER_TYPE:
            return {...state, companiesDirectorySchedulerType: action.payload}
        case GET_COMPANIES_DIRECTORIES_PHONE_TYPE:
            return {...state, campaignDirectoriesPhoneType: action.payload}
        case GET_COMPANIES_DIRECTORIES_CAMPAIGN_STRATEGY:
            return {...state, companiesDirectoryCampaignStrategy: action.payload}
        case GET_COMPANIES_DIRECTORIES_TRANKS_PHONE:
            return {...state, companiesDirectoryTranksPhones: action.payload}
        case SHOW_LOADER:
            return {...state, loading: true}
        case SHOW_CAMPAIGN_DETAIL_LOADING:
            return {...state, detailsLoading: action.payload}
        case HIDE_LOADER:
            return {...state, loading: false}
        case SHOW_LOADER_STRATEGY_DICT:
            return {...state, loadingStrategyDict: true}
        case HIDE_LOADER_STRATEGY_DICT:
            return {...state, loadingStrategyDict: false}
        case SHOW_ERROR:
            return {...state, error: true}
        case SHOW_UPDATED_ERROR:
            return {...state, errorUpdate: true}
        case SHOW_COMPANY_CREATE_MESSAGE:
            return {...state, companyCreateMessage: true}
        case SHOW_COMPANY_SAVE_MESSAGE:
            return {...state, companySaveMessage: true}
        case SHOW_COMPANY_DELETE_MESSAGE:
            return {...state, companyDeleteMessage: action.payload}
        case HIDE_COMPANY_CREATE_MESSAGE:
            return {...state, companyCreateMessage: false}
        case HIDE_COMPANY_SAVE_MESSAGE:
            return {...state, companySaveMessage: false}
        case HIDE_ERROR:
            return {...state, error: false, errorUpdate: false}
        case COMPANY_STATE_SAVE:
            return {...state, companyStateSave: action.payload}
        case INITIAL_COMPANIES_DATA:
            return {
                ...state,
                selectedCompanyId: null,
                companiesData: {
                    ...initialState.companiesData,
                    permission: {
                        branchIsBlock: false,
                        usersIsBlock: false,
                        skillGroupsIsBlock: false,
                        trunksIsBlock: false,
                        audioIsBlock: false,
                        ivrIsBlock: false,
                    },
                },
            };
        case SET_CAMPAIGN_AMD_SETTINGS:
            return {
                ...state,
                companiesData: {
                    ...state.companiesData,
                    campaignAMD: action.payload
                }
            };
        case CLEAR_ALL_STATES:
            return initialState;
        case SET_CAMPAIGN_TRUNK_IDS:
            return {...state, trunksPairs: action.payload};
        case DELETE_USER:
            return {
                ...state, companiesData:
                    {
                        ...state.companiesData,
                        campaignUsers: state.companiesData.campaignUsers.filter((item: RelationCampaignUsers) => item.userId !== action.payload)
                    }
            }
        case ADD_USER:
            let usersId = action.payload.userId.map((item: any) => {
                return item
            })
            return {
                ...state, companiesData:
                    {
                        ...state.companiesData,
                        campaignUsers: usersId.map((item: { userId: any; userLevel: any; userName: any; }) => {
                            return {userId: item.userId, userLevel: item.userLevel, userName: item.userName}
                        })
                    }
            }
        case CHANGE_CAMPAIGN_USER_LEVEL:
            return {
                ...state,
                companiesData: {
                    ...state.companiesData,
                    campaignUsers: state?.companiesData?.campaignUsers.map((user: any) =>
                        user.userId === action.payload.userId
                            ? {...user, userLevel: action.payload.userLevel}
                            : user
                    )
                }
            };
        case DELETE_SKILL_GROUP:
            return {
                ...state, companiesData:
                    {
                        ...state.companiesData,
                        skillGroups: state.companiesData.skillGroups.filter((item: any) => item.skillGroupId !== action.payload)
                    }
            }
        case ADD_SKILL_GROUP: {
            const uniqueSkillGroups: any[] = [];
            const seenSkillGroupIds = new Set<string>();
            (action.payload.skillGroupId || []).forEach((item: {
                skillGroupId: any;
                skillGroupLevel: any;
                name?: string;
                isActive?: boolean;
                isArchive?: boolean;
                campaignId?: number;
            }) => {
                if (item?.skillGroupId == null) {
                    return;
                }
                const key = String(item.skillGroupId);
                if (seenSkillGroupIds.has(key)) {
                    return;
                }
                seenSkillGroupIds.add(key);
                uniqueSkillGroups.push({
                    skillGroupId: item.skillGroupId,
                    skillGroupLevel: item.skillGroupLevel,
                    name: item.name,
                    isActive: item.isActive,
                    isArchive: item.isArchive,
                    campaignId: item.campaignId,
                });
            });
            return {
                ...state, companiesData:
                    {
                        ...state.companiesData,
                        skillGroups: uniqueSkillGroups
                    }
            }
        }
        case CHANGE_SKILL_GROUP_LEVEL:
            return {
                ...state,
                companiesData: {
                    ...state.companiesData,
                    skillGroups: state?.companiesData?.skillGroups.map((user: any) =>
                        user.skillGroupId === action.payload.skillGroupId
                            ? {...user, skillGroupLevel: action.payload.skillGroupLevel}
                            : user
                    )
                }
            };
        case ADD_SKILL_GROUP_GARBAGE: {
            const uniqueGarbage: any[] = [];
            const seenGarbageIds = new Set<string>();
            (action.payload.skillGroupId || []).forEach((item: any) => {
                const sid = item?.skillGroupId ?? item?.id;
                if (sid == null) {
                    return;
                }
                const key = String(sid);
                if (seenGarbageIds.has(key)) {
                    return;
                }
                seenGarbageIds.add(key);
                uniqueGarbage.push({
                    skillGroupId: sid,
                    displayOrder: uniqueGarbage.length + 1,
                    name: item.name,
                    isActive: item.isActive,
                    isArchive: item.isArchive,
                    campaignId: item.campaignId,
                    skillGroupLevel: item.skillGroupLevel ?? uniqueGarbage.length + 1,
                });
            });
            return {
                ...state,
                companiesData: {
                    ...state.companiesData,
                    skillGroupsGarbage: uniqueGarbage,
                },
            };
        }
        case DELETE_SKILL_GROUP_GARBAGE: {
            const updatedGarbage = state.companiesData.skillGroupsGarbage.filter(
                (item: any) => item.skillGroupId !== action.payload
            );
            const reorderedGarbage = updatedGarbage.map((item: any, index: number) => ({
                ...item,
                displayOrder: index + 1,
            }));
            return {
                ...state,
                companiesData: {
                    ...state.companiesData,
                    skillGroupsGarbage: reorderedGarbage,
                },
            };
        }
        case CHANGE_SKILL_GROUP_GARBAGE_INDEX:
            return {
                ...state,
                companiesData: {
                    ...state.companiesData,
                    skillGroupsGarbage: action.payload,
                },
            };
        case SET_COMPANY_ROOT_FIELD:
            return {
                ...state,
                companiesData: {
                    ...state.companiesData,
                    [action.payload.fieldName]: action.payload.value,
                },
            };
        case SHOW_ERROR_MESSAGE:
            return {...state, errorMessage: action.payload}
        case SHOW_ERROR_FIELD:
            return {...state, errorField: action.payload}
        case SET_ERROR_FIELDS:
            return {...state, errorFields: action.payload}
        case HIDE_ERROR_MESSAGE:
            return {...state, errorMessage: null}
        case CHANGED_SCHEDULER:
            return {...state, changeScheduler: action.payload, changedCompaniesData: action.payload}
        case CHANGED_COMPANIES_DATA:
            return {...state, changedCompaniesData: action.payload}
        case RESET_SCHEDULER:
            return {...state, companiesData: {...state.companiesData, scheduler: null}}
        case SET_CALL_CYCLES:
            const normalizedCallCycles = Array.isArray(action.payload)
                ? [...action.payload]
                    .sort((a, b) => {
                        const aOrder = a?.priorityCallType ?? Number.MAX_SAFE_INTEGER;
                        const bOrder = b?.priorityCallType ?? Number.MAX_SAFE_INTEGER;
                        return aOrder - bOrder;
                    })
                    .map((cycle: any, index: number) => ({
                    ...cycle,
                    priorityCallType: cycle?.priorityCallType ?? index + 1,
                    isFullCycle: cycle?.isFullCycle ?? false,
                    totalCount: cycle?.totalCount === undefined ? null : cycle.totalCount
                }))
                : action.payload;
            return {...state, companiesData: {...state.companiesData, callCycles: normalizedCallCycles}};
        case SET_TRANK_ID:
            return {...state, companiesData: {...state.companiesData, trunkId: action.payload}};
        case SET_INTERVAL_ID:
            return {...state, intervalId: action.payload};
        case SHOW_GET_COMPANIES_INTERVAL_ERROR:
            return {...state, getCompaniesIntervalError: action.payload};
        case SHOW_GET_ARCHIVE_COMPANIES_ERROR:
            return {...state, getArchiveCompaniesError: action.payload};
        case SHOW_GET_CAMPAIGN_DIRECTORIES_PHONE_TYPE_ERROR:
            return {...state, getCampaignDirectoriesPhoneTypeError: action.payload};
        case SHOW_GET_CAMPAIGN_DIRECTORIES_CAMPAIGN_TYPE:
            return {...state, getCampaignDirectoriesCampaignTypeError: action.payload};
        case SHOW_GET_COMPANIES_DIRECTORIES_TRANKS_PHONE_ERROR:
            return {...state, getCampaignDirectoriesGetTranksPhonesError: action.payload};
        case GET_COMPANIES_DIRECTORIES_CAMPAIGN_STRATEGY_ERROR:
            return {...state, getCampaignDirectoriesStrategyError: action.payload};
        case SET_CONTACTS_LOADER:
            return {...state, contactsLoader: action.payload}
        case SET_LOADING:
            return {...state, userLoading: action.payload};
        case GOOGLE_AUTH_SHOW_ERROR:
            return {...state, googleAuthError: action.payload};
        case TOGGLE_CAMPAIGN_DAY_ACTIVE: {
            const {dayOfWeek, isActive} = action.payload;
            // @ts-ignore
            const existingDays = state.companiesData.scheduler?.days ?? [];
            let updatedDays = [...existingDays];

            if (isActive) {
                const dayExists = updatedDays.find(day => day.dayOfWeek === dayOfWeek);
                if (!dayExists) {
                    updatedDays.push({dayOfWeek});
                }
            } else {
                updatedDays = updatedDays.filter(day => day.dayOfWeek !== dayOfWeek);
            }

            return {
                ...state,
                companiesData: {
                    ...state.companiesData,
                    scheduler: {
                        // @ts-ignore
                        ...state.companiesData.scheduler,
                        days: updatedDays,
                    },
                },
            };
        }

        case UPDATE_CAMPAIGN_SCHEDULER_TIME: {
            const {dayOfWeek, newTime, type} = action.payload;
            // @ts-ignore
            let updatedDays = state.companiesData.scheduler?.days?.map(day => {
                // @ts-ignore
                if (day.dayOfWeek === dayOfWeek) {
                    return {...day, [type]: newTime};
                }
                return day;
            });

            return {
                ...state,
                companiesData: {
                    ...state.companiesData,
                    scheduler: {
                        // @ts-ignore
                        ...state.companiesData.scheduler,
                        days: updatedDays,
                    },
                },
            };
        }
        case CAMPAIGN_ACD_FIELD:
            return {
                ...state,
                companiesData: {
                    ...state.companiesData,
                    [action.payload.section]: {
                        // @ts-ignore
                        ...state.companiesData[action.payload.section],
                        [action.payload.fieldName]: {
                            // @ts-ignore
                            ...(state.companiesData[action.payload.section]?.[action.payload.fieldName] || {}),
                            [action.payload.acdFieldName]: action.payload.value,
                        }
                    }
                }
            };
        case CAMPAIGN_CLEAR_ACD:
            return {
                ...state,
                companiesData: {
                    ...state.companiesData,
                    campaignACD: null
                }
            };
        case GET_NOTIFICATION:
            switch (action.payload.code) {
                case 105:
                    return {...state, notificationLaunch: action.payload}
                case 106:
                    return {...state, notificationSuspend: action.payload}
                case 107:
                    return {...state, notificationCancel: action.payload}
                case 108:
                    return {...state, notificationCopy: action.payload}
                case 109:
                    return {...state, notificationSuccess: action.payload}
                case 110:
                    return {...state, notificationUpdated: action.payload}
                case 111:
                    return {...state, notificationError: action.payload}
                case 112:
                    return {...state, notificationUpdatedError: action.payload}
                case 113:
                    return {...state, notificationSaveChanges: action.payload}
                case 126:
                    return {...state, userDeleteMessageText: action.payload}
                case 130:
                    return {...state, userDeleteQuestionsText: action.payload}
                default:
                    return state
            }
        case GET_NOTIFICATION_ERROR:
            return {...state, getNotificationError: action.payload}
        case GET_CAMPAIGN_ACD_DICTIONARY:
            return {...state, campaignDirectoryCampaignType: action.payload}
        case GET_CAMPAIGN_CONTACTS_PAGINATION:
            return {...state, campaignContactsPagination: {hasNext: action.payload.hasNext, pageNumber: action.payload.pageNumber}}
        case SET_STATE_CAMPAIGN:
            return {...state, stateCampaign: action.payload}
        case SET_ALL_CAMPAIGNS:
            return {...state, allCampaigns: Array?.isArray(action.payload) ? [...action.payload] : []}
        case GET_CAMPAIGNS_FOR_LEADS_LIST:
            return {...state, campaignsForLeadsList: Array?.isArray(action.payload) ? [...action.payload] : []}
        case GET_CAMPAIGN_LEADS_FILES_HISTORY:
            return {...state, campaignLeadsFilesHistory: Array?.isArray(action.payload) ? [...action.payload] : []}
        case SET_CAMPAIGN_LEADS_FILES_HISTORY_LOADER:
            return {...state, campaignLeadsFilesHistoryLoader: action.payload}
        case GET_CAMPAIGN_LEADS_FILES_PAGINATION:
            return {...state, campaignLeadsFilesPagination: {hasNext: action.payload.hasNext, pageNumber: action.payload.pageNumber}}
        case SET_CURRENT_CAMPAIGN_LEADS_FILES_PAGE:
            return {...state, campaignLeadsFilesPaginationPage: action.payload}
        case SET_CURRENT_CAMPAIGN_LEADS_FILES_SIZE:
            return {...state, campaignLeadsFilesPaginationSize: action.payload}
        default:
            return state
    }
}
